<script setup>

import KdContainer from "./kdContainer.vue";
</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="185px">
<!--  显示是哪个责任单位填写的缺失材料    -->
      <div class="suggestionTitle">
        <div>{{ form.staffName }}</div>
      </div>
<!--      <el-form-item label="责任单位" v-if="form.staffName != ''">-->
<!--        <el-input :disabled="true" v-model="form.staffName"></el-input>-->
<!--      </el-form-item>-->

      <div v-if="replenish || !replenishMaterial">
        <el-form-item label="补充根因分析材料" v-if="!replenishMaterial || form.reasonAnalystMaterial != ''">
          <el-input :disabled="replenishMaterial" placeholder="请输入根因分析材料" v-model="form.reasonAnalystMaterial" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <file-upload-list
            v-if="replenishMaterial"
            ref="fileUploadList"
            :fileList="form.replenishFile"
          ></file-upload-list>
          <drag-upload
            v-else
            ref="uploadFile"
            :accessoryList.sync="form.replenishFile"
            :httpRequest="imAction"/>
        </el-form-item>
      </div>

      <el-form-item label="是否差缺根因分析材料" prop="hasReasonAnalystMaterial">
        <el-radio-group :disabled="materialStatus"  v-model="form.hasReasonAnalystMaterial">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div>
        <div v-if="form.hasReasonAnalystMaterial == 1">
          <el-form-item label="根因分析差缺材料" prop="deficiencyAnalyst">
            <el-input placeholder="请输入根因分析差缺材料" :disabled="materialStatus" v-model="form.deficiencyAnalyst" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>

        </div>
        <div v-else>
          <el-form-item label="根因分析" prop="reasonAnalyst">
            <el-input :disabled="fileStatus" placeholder="请输入根因分析" v-model="form.reasonAnalyst" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <el-form-item>
            <file-upload-list
              v-if="fileStatus"
              ref="fileUploadList"
              :fileList="form.file"
            ></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="form.file"
              :httpRequest="imAction"/>
          </el-form-item>
        </div>
      </div>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick">通过</el-button>
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick">驳回</el-button>
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss">

</style>
<script>
import {baseURL} from "../../util/url";
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

export default {
  name: "kdReasonAnalystAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId:String,
    questionId:String,
    taskDefKey:String,
    reasonAnalystData: Object,
    reconfirm: Boolean,
    receivedForm:{
      hasReasonAnalystMaterial: {
        type: Number,
        default: 0
      },
      reasonAnalystMaterial: {
        type: String,
        default: ""
      },
      deficiencyAnalyst: {
        type: String,
        default: "",
      },
      reasonAnalyst: {
        type: String,
        default: ""
      },
      replenishFile: {
        type: String,
        default: ""
      },
      file:{
        type: Array,
        default:undefined
      }
    }
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      materialStatus: false,
      replenishMaterial: false,
      replenish: false,
      fileStatus:false,
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible:false,
      auditPassDialogVisible: false,
      form:{
        userId : "",
        staffName : "",
        hasReasonAnalystMaterial: 0,
        reasonAnalystMaterial: "",
        deficiencyAnalyst: "",
        reasonAnalyst: "",
        replenishFile: [],
        file:[],
        rejectReason:"",
        auditText: "",
      },
      rules: {
        hasReasonAnalystMaterial:[
          {
            required: true, message: "是否差缺根因分析材料不能为空", trigger: ["blur", "change"]
          }
        ],
        deficiencyAnalyst:[
          {
            required: true, message: '根因分析差缺材料不能为空', trigger: ["blur", "change"]
          }
        ],
        reasonAnalyst: [
          {
            required: true, message:'根因分析不能为空', trigger: ["blur", "change"]
          }
        ],
        rejectReason: [
          {
            required: true, message: "驳回原因不能为空", trigger: ["blur", "change"]
          }
        ]
      }
    }
  },

  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
    'form.hasReasonAnalystMaterial'(newVal) {
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate("deficiencyAnalyst")
        this.$refs.formRef.clearValidate('reasonAnalyst');
        this.form.deficiencyAnalyst = this.reasonAnalystData.deficiencyAnalyst ?? "";
        this.form.reasonAnalyst = this.reasonAnalystData.reasonAnalyst??"";

      });
    }
  },
  methods: {
    auditPassBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.auditPassDialogVisible = true;
      })

    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        reasonAnalystData: this.form,
        variables: {
          approval: true
        },
      }
      if (this.taskDefKey == 'Activity_0ataghk') {
        formData.variables.qualityManagePass = true;
      } else {
        formData.variables.qualityManagePass = false;
      }
      requestSubmitAuditKD(formData).then(res => {
        if (res.status == "0") {
          this.$DonMessage.success('审批通过!');
          this.backRouterPath();
        } else {
        this.$DonMessage.error(res.message);
      }
      })
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          reasonAnalystData: this.form,
          auditText: this.form.rejectReason,
          variables: {
            approval: false
          },
        }
        if (this.taskDefKey == 'Activity_0ataghk') {
          formData.variables.qualityManagePass = false;
        }
        requestSubmitAuditKD(formData).then(res => {
          if (res.status == "0") {
            this.$DonMessage.success('驳回成功!');
            this.dialogVisible = false;
          this.backRouterPath();
          } else {
            this.$DonMessage.error(res.message);
          }
        })
      })

    }
  },
  mounted() {
    if(this.reasonAnalystData){
      this.form.reasonAnalystMaterial = this.reasonAnalystData.reasonAnalystMaterial??"";
      this.form.hasReasonAnalystMaterial = (this.reasonAnalystData.hasReasonAnalystMaterial)?Number(this.reasonAnalystData.hasReasonAnalystMaterial):0;
      this.form.deficiencyAnalyst = this.reasonAnalystData.deficiencyAnalyst ?? "";

      this.form.reasonAnalyst = this.reasonAnalystData.reasonAnalyst??"";
      this.form.file = this.reasonAnalystData.file?this.reasonAnalystData.file:[];
      this.form.replenishFile = this.reasonAnalystData.replenishFile ?  this.reasonAnalystData.replenishFile:[];

      this.form.userId = this.reasonAnalystData.userId??"";
      this.form.staffName = this.reasonAnalystData.staffName??"";
      if (this.taskDefKey == 'Activity_18nq1e5' || this.taskDefKey == 'Activity_1vwk38v') {
        this.materialStatus = false;
        this.fileStatus = false;
        if (this.form.deficiencyAnalyst != "" || this.form.replenishFile.length > 0) {
          this.replenish = true;
        } else {
          this.replenish = false;
        }
        this.replenishMaterial = true
      } else if(this.taskDefKey == 'Activity_009xhan' ) {
        this.materialStatus = true;
        this.fileStatus = true;
        if (this.form.deficiencyAnalyst != "" || this.form.replenishFile.length > 0) {
          this.replenish = true;
        } else {
          this.replenish = false;
        }
        this.replenishMaterial = true
      } else if (this.taskDefKey == 'Activity_0q3vnwm') {
        this.materialStatus = true;
        this.fileStatus = false;
        this.replenish = true;
        this.replenishMaterial = false
      } else if( this.taskDefKey== 'Activity_0ataghk') {
        this.materialStatus = true;
        this.fileStatus = true;
        this.replenish = true;
        this.replenishMaterial = true;
      }
    }
    if(!this.materialStatus){
      this.form.hasReasonAnalystMaterial = 0;
    }
  }
}
</script>
